import { Controller } from 'stimulus';

export default class extends Controller {
  initialize(){
    this.referralCode = this.element.querySelector('input[name="referral_code"]');
    this.submitBtn = this.element.querySelector('button[type="submit"]');
    this.footer = this.element.querySelector('.card-footer');
  }

  submit(e){
    e.preventDefault();
    this.submitBtn.setAttribute('disabled','disabled');
    this.validateReferralCodeIfExist();
  }

  reload(){
    this.submitBtn.removeAttribute('disabled');
  }

  validateReferralCodeIfExist(){
    if(!this.referralCode.value || this.referralCode.value.length === 0){
      this.element.submit();
      return;
    }

    if(this.referralCode.value.length !== 6){
      this.referralCode.parentElement.setAttribute('data-error', "Format kode referral tidak memenuhi syarat (6 karakter)");
      this.reload();
      return;
    }

    window.KTApp.blockPage();
    window.Ajax.post(
      `/api/v1/users/validate_referral_code?referral_code=${this.referralCode.value}`,
      this.ajaxOptions
    );
  }

  handleSuccess(response){
    this.referralCode.parentElement.removeAttribute('data-error');
    this.element.submit();
  }

  handleFail(response){
    this.referralCode.parentElement.setAttribute('data-error', 'Kode referral tidak valid!');
    this.reload();
  }

  handleDone(response){
    window.KTApp.unblockPage();
  }

  get ajaxOptions(){
    return {
      onSuccess: this.handleSuccess.bind(this),
      onFail: this.handleFail.bind(this),
      onDone: this.handleDone.bind(this),
      headers: [
        {
          key: "Content-Type",
          value: "application/json",
        },
        {
          key: "X-CSRF-Token",
          value: window.Util.getCsrfToken(),
        }
      ]
    };
  }
}

